import React from 'react';
import PatientsMedspaPage from './PatientsMedspaPage';

const MedspaAdminPatients = () => <PatientsMedspaPage />;

export default MedspaAdminPatients;
